import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
//components
import Button from '../../components/Button';
import Table from '../../components/Table';
import { toastSuccess, toastError } from '../../utils/toast';
import { swalConfirm } from '../../utils/swal';
//icons
import { FaUserPlus, FaEdit, FaTrash, FaCheck, FaTimes, FaToggleOn, FaToggleOff } from 'react-icons/fa';
//services
import { ProyectManagerService } from '../../services/ProyectManagerService';
//utils
import { formatdateWithTime } from '../../utils/helpers';

const ProyectManager = () => {
  const [proyects, setProyects] = useState([]);
  const navigate = useNavigate();
    
  const handleAddProyect = () => {
    navigate('/proyect_manager/add', { state: { isEdit: false, proyectEdit: null } });
  };

  useEffect(() => {
    fetchProyects();
  }, []);

  const fetchProyects = async () => {
    try {
      const proyects = await ProyectManagerService.getAll();
      console.log(proyects);
      setProyects(proyects);
    } catch (error) {
      console.error('Error al obtener proyectos:', error.message);
    }
  };

   const columns = [
    {
      key: 'name',
      title: 'Nombre',
      sortable: true,
    },
    {
      key: 'email',
      title: 'Email',
      sortable: true,
    },
    {
      key: 'created_at',
      title: 'Creado',
      sortable: true,
      render: (value) => formatdateWithTime(value)
    },
    {
      key: 'actions',
      title: 'Acciones',
      sortable: false,
      render: (_, proyect) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleEdit(proyect)} 
            className={`rounded-full bg-blue-500 hover:transition-all hover:bg-blue-600 text-white p-[8px] items-center justify-center flex gap-1`}
            title="Editar"
          >
            <FaEdit />
          </button>
          <button
            onClick={() => handleDelete(proyect.id)} 
            className={`rounded-full bg-red-500 hover:transition-all hover:bg-red-600 text-white p-[8px] items-center justify-center flex gap-1`}
            title="Eliminar"
          >
            <FaTrash />
          </button>
        </div>
      )
    },
  ];

  // Opciones de la tabla
  const tableOptions = {
    pagination: true,
    pageSize: 5,
    pageSizeOptions: [5, 10, 20],
    showSearch: true,
    searchPlaceholder: 'Buscar manager...',
    emptyMessage: 'No hay managers disponibles',
  };

  const handleEdit = (proyect) => {
    navigate('/proyect_manager/add', { state: { isEdit: true, proyectEdit: proyect } });
  }

  const handleDelete = async (proyectId) => {
    const { isConfirmed } = await swalConfirm(
      '¿Eliminar manager?',
      '¿Está seguro de que desea eliminar este manager? Esta acción no se puede deshacer.',
      'Sí, eliminar',
      {
        // Aseguramos que no se muestren campos de formulario ni botones adicionales
        input: null,
        html: null,
        footer: null,
        showDenyButton: false,
        denyButtonText: undefined
      }
    );
    
    if (isConfirmed) {
      await ProyectManagerService.deleteProyect(proyectId);
      fetchProyects();
      toastSuccess('Proyecto eliminado correctamente');
    }
  }

  return (
    <div className="bg-surface-card border border-white/[0.06] rounded-xl p-6">
      <div className="flex justify-end items-center mb-6">
        <Button
          variant="warning"
          onClick={handleAddProyect}
        >
          <FaUserPlus className="mr-2" /> 
          Agregar Proyecto Manager
        </Button>
      </div>
      <div className="w-full">
        <Table 
          data={proyects} 
          columns={columns} 
          options={tableOptions} 
        />
      </div>
    </div>
  )
}

export default ProyectManager
